import getCourseRating from "../api/getCourseRating";

export const saveCourseRating = async ({ index, courses, websiteId }) => {
  const course = courses[index] ?? courses[0];
  const courseId = course?.courseId;
  try {
    if (websiteId && courseId) {
      const data = await getCourseRating({
        websiteId: websiteId,
        courseId: courseId,
      });
      if (data) {
        localStorage.setItem("courseRating", JSON.stringify(data));
      }
    }
  } catch (error) {
    console.log("Failed to save course rating:", error);
  }
};
